import { Outlet } from 'react-router'

import { CachedLoaderDataContextProvider } from '../../hooks/useCachedLoaderData'
import { parseRouteInitData } from '../../util-routing'
import Layout from './components/Layout'

export const calendarModule = [
  {
    path: '/calendar',
    loader: parseRouteInitData,
    Component: () => (
      <CachedLoaderDataContextProvider>
        <Layout>
          <Outlet />
        </Layout>
      </CachedLoaderDataContextProvider>
    ),
    children: [
      {
        path: 'economic',
        LazyComponent: () => import(/* webpackChunkName: "calendar-economic" */ './routes/Economic'),
      },
      {
        path: 'economic/detail/:ticker',
        LazyComponent: () => import(/* webpackChunkName: "calendar-economic-detail" */ './routes/EconomicDetail'),
      },
      {
        path: 'earnings',
        LazyComponent: () => import(/* webpackChunkName: "calendar-earnings" */ './routes/Earnings'),
      },
      {
        path: 'dividends',
        LazyComponent: () => import(/* webpackChunkName: "calendar-dividends" */ './routes/Dividends'),
      },
    ],
  },
]
